import { IGetPublicStatusResponse } from 'services/businessPlan/types';

import { useModalContext } from 'components/ModalManager';
import { ManageOnePageShare } from 'components/ShareOnePage/components';
import { ShareProjectModal } from 'components/ShareProjectModal/ShareProjectModal';

interface IUseManageDocumentShare {
  uuid: string;
  linkStatus?: IGetPublicStatusResponse;
}

export const useManageDocumentShare = ({ uuid, linkStatus }: IUseManageDocumentShare) => {
  const { showModal, hideModal } = useModalContext();

  const sharePDFLinkModal = () => {
    showModal(ShareProjectModal, {
      onClose: hideModal,
      id: uuid,
    });
  };

  const manageOnePageShare = () =>
    showModal(ManageOnePageShare, {
      onClose: hideModal,
      isOpened: true,
      id: uuid,
      openLinkStatus: linkStatus?.openLinkStatus,
    });

  return { sharePDFLinkModal, manageOnePageShare };
};
